import { useEffect, useMemo, useState } from 'react';

const readInnerWidth = (): number => {
  return typeof window !== 'undefined' ? window.innerWidth : 0;
};

const readInnerHeight = (): number => {
  return typeof window !== 'undefined' ? window.innerHeight : 0;
};

const useWindowSize = (): { width: number; height: number; isNarrow: boolean } => {
  const [size, setSize] = useState({ width: readInnerWidth(), height: readInnerHeight() });

  useEffect(() => {
    const onResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isNarrow = useMemo(() => {
    return size.width < 1920 || size.height < 800;
  }, [size]);

  return { ...size, isNarrow };
};

export default useWindowSize;
